import Embla, { EmblaOptionsType, EmblaCarouselType } from "embla-carousel";
const lightboxes = document.querySelectorAll<HTMLElement>(
    ".lightbox-carousel"
);

function createLightboxCarousel(lightbox: HTMLElement) {
    const embla = Embla(lightbox, { loop: false, skipSnaps: false });

    const prevBtn = lightbox.querySelector(".embla__button--prev");
    const nextBtn = lightbox.querySelector(".embla__button--next");

    setupPrevNextBtns(prevBtn, nextBtn, embla);

    const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);
    embla.on("select", disablePrevAndNextBtns);
    embla.on("init", disablePrevAndNextBtns);

    // embla needs to reinit because the size of the box has changed when the modal is shown.
    lightbox.closest('.modal').addEventListener('shown.bs.modal', () => {
        embla.reInit()
    });
}

const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
    prevBtn.addEventListener("click", embla.scrollPrev);
    nextBtn.addEventListener("click", embla.scrollNext);
};

const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
    return () => {
        if (embla.canScrollPrev()) prevBtn.removeAttribute("disabled");
        else prevBtn.setAttribute("disabled", "disabled");

        if (embla.canScrollNext()) nextBtn.removeAttribute("disabled");
        else nextBtn.setAttribute("disabled", "disabled");
    };
};

for (const lightbox of lightboxes) {
    createLightboxCarousel(lightbox);
}

